import { terUtilsUnitsMilimetriToMetri } from './ter-utils';
import { XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _getFromLibMaterijalLimSingleParam } from './ter-materijal-utils';
import { DOT, SLASH, SPACE } from '../utils/frfr-string-consts';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';


/*
export const derivatPoluproizvod_elasticnaveza_dopuni = (p) => {
  // SPECIJALNI KORAK
  // _____ dodajemo neke podatke koji su mu potrebni!
};
*/


const _materijal_naziv_make = (prirubnica) => {
  // const I2 = prirubnica;
  const _materijal_naziv = XIF(prirubnica === "METZ 20", _getFromLibMaterijalLimSingleParam("PM20DDA000005000", "naziv"), XIF(prirubnica === "METZ 30", _getFromLibMaterijalLimSingleParam("PM30DDA000005000", "naziv")));
  return _materijal_naziv;
};


export const derAutoCreateVirbom_terkk_elasticnaveza_prepare_vir_input = (p) => {
  const prirubnica = p.prirubnica;
  const platno = p.platno;
  const sirinaa = p.sirinaa;
  const visinab = p.visinab;
  const kolicina = p.kolicina;

  const v_input = {
    prirubnica,
    platno,
    sirinaa,
    visinab,
    kolicina,
  };

  return v_input;
};


export const derAutoCreateVirbom_terkk_elasticnaveza_children = (v_input) => {

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // promenljive iz excela
  const prirubnica = v_input.prirubnica;
  const I3 = v_input.platno;
  const I4 = v_input.sirinaa;
  const I5 = v_input.visinab;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // derivat 1
  // derivat local 1
  _derivat_key = "derivat1";
  x = {
    _tracking_key: _derivat_key,
    virtelschemakey: 'terkk$elasticnaveza$derivat1',
    virtelclass: "terkk$elasticnaveza$profil",
    // kolicina: 2,
    kolicina: 4, // DL 2023-11-28: "derivat1"; kolicina umesto 2 treba 4
  };
  x.duzina = I4 - 5;
  x.calculated_ident = XIF(prirubnica === "METZ 20", _getFromLibMaterijalLimSingleParam("PM20DDA000005000", "ident"), XIF(prirubnica === "METZ 30", _getFromLibMaterijalLimSingleParam("PM30DDA000005000", "ident"), "IZABERI TIP PRIRUBNICE"));
  x.tip = XIF(prirubnica === "METZ 20", _getFromLibMaterijalLimSingleParam("PM20DDA000005000", "ident"), XIF(prirubnica === "METZ 30", _getFromLibMaterijalLimSingleParam("PM30DDA000005000", "ident"), "IZABERI TIP PRIRUBNICE"));
  _materijal_naziv = _materijal_naziv_make(prirubnica);
  x._materijal_naziv = _materijal_naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$elasticnaveza$profil"),
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 1.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_elasticnaveza_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$elasticnaveza$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 3
  // derivat local 3
  _derivat_key = "derivat3";
  x = {
    _tracking_key: _derivat_key,
    virtelschemakey: 'terkk$elasticnaveza$derivat1',
    virtelclass: "terkk$elasticnaveza$profil",
    // kolicina: 2,
    kolicina: 4, // DL 2023-11-28: "derivat3"; kolicina umesto 2 treba 4
  };
  x.duzina = I5 - 5;
  x.calculated_ident = XIF(prirubnica === "METZ 20", _getFromLibMaterijalLimSingleParam("PM20DDA000005000", "ident"), XIF(prirubnica === "METZ 30", _getFromLibMaterijalLimSingleParam("PM30DDA000005000", "ident"), "IZABERI TIP PRIRUBNICE"));
  x.tip = XIF(prirubnica === "METZ 20", _getFromLibMaterijalLimSingleParam("PM20DDA000005000", "ident"), XIF(prirubnica === "METZ 30", _getFromLibMaterijalLimSingleParam("PM30DDA000005000", "ident"), "IZABERI TIP PRIRUBNICE"));
  _materijal_naziv = _materijal_naziv_make(prirubnica);
  x._materijal_naziv = _materijal_naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x = {
    ...x,
    ..._getParamsFromLib("terkk$elasticnaveza$profil"),
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 3.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_elasticnaveza_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _tracking_key: _derivat_key,
    _local_bomlevel: x._local_bomlevel + DOT + '1',
    _local_graphpath: x._local_graphpath + SLASH + _derivat_key,
    virtelschemakey: 'terkk$elasticnaveza$materijal1',
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // ZATIM SLEDI JOS 3 MATERIJALA ZA ELASTICNU VEZU


  // derivat 5
  // derivat local 5 MATERIJAL
  _derivat_key = "derivat5";
  x = {
    _tracking_key: _derivat_key,
    virtelschemakey: 'terkk$elasticnaveza$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_M,
    kolicina: 1,
    tip: ''
  };
  x.duzina = ((I4 + I5) * 2 + 15);
  x.kolicina = terUtilsUnitsMilimetriToMetri(x.duzina, 3);
  x.calculated_ident = XIF(I3 === "STANDARDNA", _getFromLibMaterijalLimSingleParam("A040000000000019", "ident"), XIF(I3 === "VATROOTPORNA", _getFromLibMaterijalLimSingleParam("A040000000000005", "ident"), "IZABERI TIP PRIRUBNICE"));
  x.naziv = XIF(I3 === "STANDARDNA", _getFromLibMaterijalLimSingleParam("A040000000000019", "naziv"), XIF(I3 === "VATROOTPORNA", _getFromLibMaterijalLimSingleParam("A040000000000005", "naziv"), "IZABERI TIP PRIRUBNICE"));
  _materijal_naziv = x.naziv;
  x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 6
  // derivat local 6 MATERIJAL
  _derivat_key = "derivat6";
  x = {
    _tracking_key: _derivat_key,
    virtelschemakey: 'terkk$elasticnaveza$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_M,
    kolicina: 1,
    tip: ''
  };
  x.duzina = 150;
  x.kolicina = terUtilsUnitsMilimetriToMetri(x.duzina, 3);
  x.calculated_ident = _getFromLibMaterijalLimSingleParam("A040000000000018", "ident");
  x.naziv = _getFromLibMaterijalLimSingleParam("A040000000000018", "naziv");
  // z["derivat6"] = x;
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat 7
  // derivat local 7 MATERIJAL
  _derivat_key = "derivat7";
  x = {
    _tracking_key: _derivat_key,
    virtelschemakey: 'terkk$elasticnaveza$materijal2',
    terkategorija: 'M',
    jm: tclocal.JM_M,
    kolicina: 8,
    tip: ''
  };
  x.duzina = '';
  x.calculated_ident = XIF(prirubnica === "METZ 20", _getFromLibMaterijalLimSingleParam("A030020000000001", "ident"), XIF(prirubnica === "METZ 30", _getFromLibMaterijalLimSingleParam("A030020000000002", "ident"), "IZABERI TIP PRIRUBNICE"));
  x.naziv = XIF(prirubnica === "METZ 20", _getFromLibMaterijalLimSingleParam("A030020000000001", "naziv"), XIF(prirubnica === "METZ 30", _getFromLibMaterijalLimSingleParam("A030020000000002", "naziv"), "IZABERI TIP PRIRUBNICE"));
  // z["derivat7"] = x;
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


export const _derivat_elasticnaveza_materijal1_by_pp = (p) => {

  // TODO: proveriti da li i p prima prirubnicu kao input ili daje kao rezultat...

  const _mateirjal_priprema_ulaza = (p) => {
    const _materijal_naziv = p._materijal_naziv;
    const prirubnica = p.prirubnica;
    const tip = p.tip;
    const duzina = p.duzina;
    const v_input = {
      prirubnica,
      tip,
      duzina,
      _materijal_naziv
    };
    return v_input;
  };

  const _materijal_make = (v_input) => {
    // dodajem mu materijal!
    const prirubnica = v_input.prirubnica;
    // let z;
    let x = {
      naziv: v_input._materijal_naziv
    };

    x.calculated_ident = v_input.tip;
    x.terkategorija = 'M';
    x.jm = tclocal.JM_M;
    let _kolicina = v_input.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    x.kolicina = terUtilsUnitsMilimetriToMetri(_kolicina, 3); // KONVERTUJEMO U METRE
    // z["derivat2"] = x;
    // posto materijal nece na backendu da se cuva odmah ovde delimicno kompletiramo virtel plitki
    const virtel_plitki_materijal = {
      // ...v_input,
      ...x
    };
    return virtel_plitki_materijal;

    // TODO: ovde imamo dva puta polje kolicina
  };

  const v_input = _mateirjal_priprema_ulaza(p);
  const materijal = _materijal_make(v_input);
  return materijal;
};
